var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69.118695px",
    height: "79.9897778px",
    viewBox: "0 0 69.118695 79.9897778",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo/ap copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 69.118695 0 69.118695 79.9897778 0 79.9897778"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Header-&-Footers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footers",
    transform: "translate(-200.000000, -352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(100.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo/ap-copy-3",
    transform: "translate(100.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "0.000666739823 71.6506667 69.118695 71.6506667 69.118695 0 0.000666739823 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#FF322E",
    mask: "url(#mask-2)",
    points: "0 71.6506667 69.118695 71.6506667 69.118695 80.0031111 0.000666739823 80.0031111 0 71.6506667"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#000000",
    points: "15.9095234 18.8546667 4.2911375 53.7011111 12.7031716 53.7011111 20.5947041 29.0704444 24.550027 41.3844444 19.4334656 41.3844444 17.3901303 48.4137778 26.8078303 48.4137778 28.5060166 53.7011111 37.1585216 53.7011111 25.5414691 18.8546667 15.9095234 18.8546667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3773053,18.8546667 L38.2999801,18.8546667 L38.2999801,53.7011111 L46.6520077,53.7011111 L46.6520077,25.8842222 L50.017488,25.8842222 C53.9225832,25.8842222 56.1459382,27.7462222 56.1459382,31.1108889 C56.1459382,34.4153333 53.9225832,36.338 50.017488,36.338 L49.476762,36.338 L49.476762,43.3673333 L50.3773053,43.3673333 C59.3902942,43.3673333 64.6779855,38.8308889 64.6779855,31.1108889 C64.6779855,23.2404444 59.3902942,18.8546667 50.3773053,18.8546667",
    id: "Fill-6",
    fill: "#000000"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApNews);
export default __webpack_public_path__ + "static/media/AP-news.7f4ed5dbf8565a85e06c4ab18f67a687.svg";
export { ForwardRef as ReactComponent };